export default __webpack_public_path__ + "static/media/ve_5.b111b6d4.mp3";